/**
 * @generated SignedSource<<29783cd2e87dfd17e3392da1ddbf09f0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerCardHeader_appointment$data = {
  readonly channel: CommunicationChannel;
  readonly date: any;
  readonly service: Service;
  readonly slotId: number;
  readonly " $fragmentType": "appointmentDrawerCardHeader_appointment";
};
export type appointmentDrawerCardHeader_appointment$key = {
  readonly " $data"?: appointmentDrawerCardHeader_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerCardHeader_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerCardHeader_appointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slotId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "channel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "service",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "9472f4820c2a4e340aaa319629d24d9d";

export default node;
